// @flow
import Projection from "./Projection";
import { clamp } from "../../util/util";

export default class LonLat extends Projection {
    constructor() {
        super();
        this.bounds = [-180, -90, 180, 90];
    }

    project(lnglat) {
        const [lng, lat] = super.project(lnglat);
        return [
            clamp(lng, this.bounds[0], this.bounds[2]),
            clamp(lat, this.bounds[1], this.bounds[3]),
        ];
    }

    unproject(point) {
        const [x, y] = super.unproject(point);
        return [
            clamp(x, this.bounds[0], this.bounds[2]),
            clamp(y, this.bounds[1], this.bounds[3]),
        ];
    }
}
